import { z } from 'zod';

export const imageUploadSchema = z.object({
  imageStorageKey: z.string(),
  thumbnailStorageKey: z.string(),
});
export type ImageUpload = z.infer<typeof imageUploadSchema>;
